
import moment from "moment";
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/themes/material_blue.css";
import cities from '../../Data/Cities.json';
import { Link, useNavigate } from 'react-router-dom';
import React, { useState, useEffect, useRef, useContext } from 'react'; 
import { LandingContext } from '../Profile/LandingContext';
import DefaultData from "../../CompanyData/DefaultData";
const HotelSearchPanel = () => {
    const navigate = useNavigate();
    const landingData = useContext(LandingContext); 
    const [isDomestic, setIsDomestic] = useState('INTERNATIONAL');
    const [roomInfo, setRoomInfo] = useState([
        {
            adults: 1,
            kids: 1,
            kidsAge: [2],
            adultsFields: [{ title: "Mr", firstName: "", lastName: "", travelerType: "ADULT", dateOfBirth: new Date(), panCard: "", passportNo: "", passportNationality: "", passbookIssueDate: new Date(), passbookExpireDate: new Date() }],
            kidsFields: [{ title: "Miss", firstName: "", lastName: "", travelerType: "CHILD", dateOfBirth: new Date(), panCard: "", passportNo: "", passportNationality: "", passbookIssueDate: new Date(), passbookExpireDate: new Date() }]
        }
    ]);
    const handleChildAgeChange = (roomIndex, childIndex, value) => {
        const updatedRoomInfo = [...roomInfo];
        updatedRoomInfo[roomIndex].kidsAge[childIndex] = value;
        console.log(updatedRoomInfo);
        setRoomInfo(updatedRoomInfo);
    };
    const addRoom = (e) => {
        e.stopPropagation();
        setRoomInfo([
            ...roomInfo,
            {
                adults: 1,
                kids: 1,
                kidsAge: [2],
                adultsFields: [{ title: "Mr", firstName: "", lastName: "", travelerType: "ADULT", dateOfBirth: new Date(), panCard: "", passportNo: "", passportNationality: "", passbookIssueDate: "", passbookExpireDate: "" }],
                kidsFields: [{ title: "Miss", firstName: "", lastName: "", travelerType: "CHILD", dateOfBirth: new Date(), panCard: "", passportNo: "", passportNationality: "", passbookIssueDate: "", passbookExpireDate: "" }]
            }
        ]);
        setTotalRooms(parseInt(totalRooms + 1));
        setTotalAdults(parseInt(totalAdults + 1))
        setTotalKids(parseInt(totalKids + 1))
    };
    const deleteRoom = (e, index) => {
        e.stopPropagation()
        if (index !== 0) {
            const updatedRoomInfo = [...roomInfo];
            updatedRoomInfo.splice(index, 1);
            setRoomInfo(updatedRoomInfo);
            setTotalRooms(parseInt(totalRooms - 1));
            setTotalAdults(parseInt(totalAdults - 1))
            setTotalKids(parseInt(totalKids - 1))
        }
    };
    const [displayFrom, setDisplayFrom] = useState('DUBAI, DUBAI, UNITED ARAB EMIRATES');
    const [cityId, setCityId] = useState('147862');
    const [city, setCity] = useState('DUBAI');
    const [country, setCountry] = useState('UNITED ARAB EMIRATES');
    const [totalGuests, setTotalGuests] = useState(2);
    const [checkInDate, setCheckInDate] = useState(new Date());
    const [checkOutDate, setCheckOutDate] = useState(new Date());
    const [totalAdults, setTotalAdults] = useState(1);
    const [totalKids, setTotalKids] = useState(1);
    const [totalRooms, setTotalRooms] = useState(1);
    const [errors, setErrors] = useState({});
    const [cityResults, setCityResults] = useState([]);
    const inputCRef = useRef(null);
    const handleCitySearch = (e) => {
        const value = e.target.value;
        setDisplayFrom(value);
        if (value.length > 0) {
            const filteredCities = cities
                .filter(city =>
                    city.cityName.toLowerCase().includes(value.toLowerCase()) && city.type !== 'MULTI_CITY_VICINITY'
                )
                .slice(0, 10);
            setCityResults(filteredCities);
        } else {
            setCityResults([]);
        }
    };
    const handleCityClick = (e) => {
        const filteredCities = cities.slice(0, 10);
        setCityResults(filteredCities);
        inputCRef.current.select();
    };
    const handleCitySelect = (data) => {
        var DF = data.fullRegionName;
        if (data.countryName !== "INDIA") {
            setIsDomestic('INTERNATIONAL')
        }
        else {
            setIsDomestic('DOMESTIC')
        }
        setDisplayFrom(DF);
        setCityId(data.id)
        setCity(data.cityName)
        setCountry(data.countryName)
        setCityResults([]);
    }
    const validate = () => {
        let temp = {};
        temp.displayFrom = displayFrom === "" ? false : true;
        setErrors(temp);
        return Object.values(temp).every((x) => x === true);
    };
    const handleSearch = (e) => {
        e.preventDefault();
        if (validate()) {
            const searchQuery = {
                "cityCode": '' + cityId,
                "city": city,
                "displayFrom": displayFrom,
                "checkInDate": moment(checkInDate).format('YYYY-MM-DD'),
                "checkOutDate": moment(checkOutDate).format('YYYY-MM-DD'),
                "nationality": "106",
                "currency": "INR",
                "country": country,
                "rating": [2, 3, 4, 5],
                "hotelRooms": roomInfo,
                "requestedBy": "CUSTOMER",
                "totalGuests": parseInt(totalAdults + totalKids),
                "totalAdults": totalAdults,
                "totalKids": totalKids,
                "totalRooms": totalRooms,
                "companyId": DefaultData?.DEFAULTCOMPANYID,
                "isDomestic": isDomestic
            }
            navigate('/hotels/', { state: { searchQuery } });
        }
    }
    const handleIncreaseAdults = (e, index, adultvalue) => {
        e.stopPropagation();
        if (adultvalue < 7) {
            const value = parseInt(adultvalue + 1);
            const updatedRoomInfo = [...roomInfo];
            updatedRoomInfo[index].adults = value;
            const avalues = [];
            for (var i = 0; i < value; i++) {
                avalues.push({ title: "Mr", firstName: "", lastName: "", travelerType: "ADULT", dateOfBirth: new Date(), panCard: "", passportNo: "", passportNationality: "", passbookIssueDate: "", passbookExpireDate: "" });
                updatedRoomInfo[index].adultsFields = avalues;
            }
            setTotalAdults(parseInt(totalAdults + 1))
            setTotalGuests(parseInt(totalGuests + 1))
            setRoomInfo(updatedRoomInfo);
        }

    }
    const handleDecreaseAdults = (e, index, adultvalue) => {
        e.stopPropagation();
        if (adultvalue !== 1) {
            const value = parseInt(adultvalue - 1);
            const updatedRoomInfo = [...roomInfo];
            updatedRoomInfo[index].adults = value;
            const avalues = [];
            for (var i = 0; i < value; i++) {
                avalues.push({ title: "Mr", firstName: "", lastName: "", travelerType: "ADULT", dateOfBirth: new Date(), panCard: "", passportNo: "", passportNationality: "", passbookIssueDate: "", passbookExpireDate: "" });
                updatedRoomInfo[index].adultsFields = avalues;
            }
            setRoomInfo(updatedRoomInfo);
            setTotalAdults(parseInt(totalAdults - 1))
            setTotalGuests(parseInt(totalGuests - 1))
        }
    }
    const handleIncreaseKids = (e, index, kidvalue) => {
        e.stopPropagation();
        if (kidvalue < 4) {
            const value = parseInt(kidvalue + 1);
            const updatedRoomInfo = [...roomInfo];
            updatedRoomInfo[index].kids = value;
            updatedRoomInfo[index].kidsAge = new Array(value).fill(1);
            const avalues = [];
            for (var i = 0; i < value; i++) {
                avalues.push({ title: "Miss", firstName: "", lastName: "", travelerType: "CHILD", dateOfBirth: new Date(), panCard: "", passportNo: "", passportNationality: "", passbookIssueDate: "", passbookExpireDate: "" });
                updatedRoomInfo[index].kidsFields = avalues;
            }
            setRoomInfo(updatedRoomInfo);
            setTotalKids(parseInt(totalKids + 1))
            setTotalGuests(parseInt(totalGuests + 1))
        }
    }
    const handleDecreaseKids = (e, index, kidvalue) => {
        e.stopPropagation();
        if (kidvalue !== 0) {
            const value = parseInt(kidvalue - 1);
            const updatedRoomInfo = [...roomInfo];
            updatedRoomInfo[index].kids = value;
            updatedRoomInfo[index].kidsAge = new Array(value).fill(1);
            const avalues = [];
            for (var i = 0; i < value; i++) {
                avalues.push({ title: "Miss", firstName: "", lastName: "", travelerType: "CHILD", dateOfBirth: new Date(), panCard: "", passportNo: "", passportNationality: "", passbookIssueDate: "", passbookExpireDate: "" });
                updatedRoomInfo[index].kidsFields = avalues;
            }
            if (value === 0) {
                updatedRoomInfo[index].kidsFields = avalues;
            }
            setRoomInfo(updatedRoomInfo);
            setTotalKids(parseInt(totalKids - 1))
            setTotalGuests(parseInt(totalGuests - 1))
        }
    }
    const handleCheckInDate = (date) => {
        const selectedDate = date[0];
        setCheckInDate(selectedDate);

        // If returnDate is before the new departureDate, reset it to departureDate
        if (checkOutDate && selectedDate && checkOutDate < selectedDate) {
            const newDate = new Date(selectedDate.getTime());
            setCheckOutDate(newDate.setDate(newDate.getDate() + 1));
        }
    }
    const handleCheckOutDate = (date) => {
        const selectedDate = date[0];
        if (selectedDate !== null) {
            setCheckOutDate(selectedDate);
            const newDate = new Date(selectedDate.getTime());
            if (moment(newDate).format('DD-MM-YYYY') <= moment(checkInDate).format('DD-MM-YYYY')) {
                setCheckOutDate(newDate.setDate(newDate.getDate() + 1));
            }
            else {
                setCheckOutDate(newDate.setDate(newDate.getDate()));
            }

        }
    }
    const addDays = (cdate) => {
        if (cdate === undefined) {
            cdate = new Date();
        }
        const newDate = new Date(cdate.getTime());
        setCheckOutDate(newDate.setDate(cdate.getDate() + 1));
    }
    useEffect(() => {
        addDays(checkInDate);
    }, [])

    const searchButtonStyle = {
        backgroundColor: landingData?.themeColor1 || '#fd5b2f', // Use theme color, fallback to original orange
        borderColor: landingData?.themeColor1 || '#fd5b2f',
    };


    return (
            <div className="hotel-search-bar">
                <div className="card-body">
                    <div className="row gy-3 gx-lg-2 gx-3">
                        <div className="col-3">
                            <label htmlFor="iconInput" className="form-label">CITY</label>
                            <div className="form-icon position-relative">
                                <input className="form-control" type="text" placeholder="Search for an city" value={displayFrom} onChange={handleCitySearch} onClick={handleCityClick} onFocus={handleCityClick} ref={inputCRef} />
                                <i className="ri-map-pin-line" />
                            </div>
                            {errors.displayFrom === false ? (<div className="validationerror">Please select city </div>) : ('')}
                            {cityResults.length > 0 && (
                                <ul className="locationListVideo scrollable-list" style={{ minWidth: "350px", maxWidth: "400px" }}>
                                    {cityResults.map((city) => (
                                        <li className="locationListVideoItem" key={city.id} onClick={() => handleCitySelect(city)}>
                                            {city.fullRegionName}
                                        </li>
                                    ))}
                                </ul>
                            )}
                        </div>
                        <div className="col-2">
                            <label htmlFor="iconInput" className="form-label">CHECK-IN</label>
                            <div className="input-group">
                                <Flatpickr className="form-control" name="checkInDate"
                                    value={checkInDate}
                                    onChange={(date) => handleCheckInDate(date)}
                                    options={{ dateFormat: "d M Y", minDate: "today" }} />
                                {errors.checkInDate === false ? (<div className="validationerror">Please select checkInDate </div>) : ('')}
                                <div className="input-group-text bg-primary border-primary text-white">
                                    <i className="ri-calendar-2-line"></i>
                                </div>
                            </div>
                        </div>
                        <div className="col-2">
                            <label htmlFor="iconInput" className="form-label">CHECK-OUT</label>
                            <div className="input-group">
                                <Flatpickr className="form-control" value={checkOutDate} name="checkOutDate"
                                    onChange={(date) => { handleCheckOutDate(date) }}
                                    options={{ dateFormat: "d M Y", minDate: checkInDate, }} />
                                {errors.checkOutDate === false ? (<div className="validationerror">Please select checkOutDate </div>) : ('')}
                                <div className="input-group-text bg-primary border-primary text-white">
                                    <i className="ri-calendar-2-line"></i>
                                </div>
                            </div>
                        </div>
                        <div className="col-3">
                            <label htmlFor="iconInput" className="form-label">ROOMS & GUESTS</label>
                            <div class="dropdown" data-bs-auto-close="outside">
                                <div class=" form-control w-100 dropdown-toggle" type="button" id="dropdownMenuButton"
                                    data-bs-toggle="dropdown" aria-expanded="false">
                                    {totalRooms + " Rooms, " + totalAdults + " Adults, " + totalKids + " Children"}
                                </div>
                                <div className="dropdown-menu p-3" aria-labelledby="dropdownMenuButton">
                                    <div className="mb-3">
                                        {roomInfo.map((room, index) => (
                                            <div key={index} className="row mb-2">
                                                {console.log(room)}
                                                <div className="col-12 d-flex justify-content-between w-100">
                                                    <span defaultValue={1} readOnly value={room.adults} name="adults">
                                                        <span>Adults</span>
                                                        <div className="input-step d-flex align-items-center">
                                                            <button type="button" className="minus" onClick={e => handleDecreaseAdults(e, index, room.adults)}>–</button>
                                                            <input type="number" className="product-quantity text-center" min="1" max="9" readOnly value={room.adults} name="adults" />
                                                            <button type="button" className="plus" onClick={e => handleIncreaseAdults(e, index, room.adults)}>+</button>
                                                        </div>
                                                    </span>
                                                    <span defaultValue={0} readOnly value={room.kids} name="kids">
                                                        <span>Kids</span>
                                                        <div className="input-step d-flex align-items-center">
                                                            <button type="button" className="minus" onClick={e => handleDecreaseKids(e, index, room.kids)}>–</button>
                                                            <input type="number" className="product-quantity text-center" min="0" max="9" readOnly value={room.kids} name="kids" />
                                                            <button type="button" className="plus" onClick={e => handleIncreaseKids(e, index, room.kids)}>+</button>
                                                        </div>
                                                    </span>
                                                    <span className='mt-3'>
                                                        {index !== 0 && (
                                                            <Link onClick={(e) => deleteRoom(e, index)} className="btn btn-danger">
                                                                <i className="ri-delete-bin-line"></i>
                                                            </Link>
                                                        )}
                                                    </span>
                                                </div>
                                                {/* Kids Age Section */}
                                                <div className="row mt-2">
                                                    {room.kidsAge.length > 0 &&
                                                        room.kidsAge.map((age, childIndex) => (
                                                            <div className="col-lg-4" key={childIndex}>
                                                                <label>Age {childIndex + 1}</label>
                                                                <select className="form-select" value={age} onChange={e => handleChildAgeChange(index, childIndex, parseInt(e.target.value))}>
                                                                    {[...Array(11)].map((_, i) => {
                                                                        const val = i + 2; // Start from 2 up to 12
                                                                        return (
                                                                            <option key={val} value={val}>
                                                                                {val}
                                                                            </option>
                                                                        );
                                                                    })}
                                                                </select>
                                                            </div>
                                                        ))}
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                    <div className="mb-3 d-flex justify-content-between align-items-center">
                                        <Link onClick={addRoom} className="btn btn-primary">Add Room</Link>
                                        <Link className="btn btn-success">Done</Link>
                                    </div>

                                </div>
                            </div>
                        </div>
                        <div className="col-auto px-1" style={{ paddingTop: "28px" }}>
                            <div className="form-group mb-0">
                               <button 
                                type="button" 
                                className="btn btn-danger btn-search full-width fw-medium" // The btn-danger class can be removed
                                onClick={handleSearch}
                                style={searchButtonStyle}
                            >
                                <i className="fa-solid fa-search-arrow ms-2" />SEARCH
                            </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

    );
};

export default HotelSearchPanel;